/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable no-nested-ternary */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/destructuring-assignment */
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";

import { useIsComponentMounted } from "../hooks/useIsComponentMounted";

interface IProps {
  value: string[];
  setValue: (value: string[]) => void;
  records: string[];
  noOptionsText?: string;
  placeholder?: string;
  freeSolo?: boolean;
  disabled?: boolean;
  size?: "small" | "medium";
  variant?: "standard" | "outlined" | "filled";
}

const NitroAutocompleteMulti = (props: IProps) => {
  // const [options, setOptions] = useState([] as any[]);

  const isComponentMounted = useIsComponentMounted();

  return (
    <Autocomplete
      multiple
      disablePortal
      disableClearable
      size={props.size || "small"}
      fullWidth
      disabled={props.disabled}
      freeSolo={props.freeSolo}
      options={props.records}
      // options={isLoading ? [props.value] : options || [props.value]}
      value={props.value}
      onChange={(e: any, newValue: any) => {
        if (!isComponentMounted) return;

        if (props.freeSolo && !e.target.innerText) {
          return;
        }
        props.setValue(newValue);
      }}
      renderInput={(params) => (
        <TextField
          // {...params}
          id={params.id}
          key="Testing"
          // disabled
          variant={props.variant || "outlined"}
          size={props.size || "small"}
          multiline
          fullWidth
          value={props.value}
          // placeholder={props.placeholder}
          inputProps={{ ...params.inputProps }}
          InputProps={{
            ...params.InputProps,
            style: {
              paddingTop: 1,
              paddingBottom: 1,
            },
          }}
          InputLabelProps={{ ...params.InputLabelProps }}
        />
      )}
      renderOption={(params, option: any) => (
        <li
          {...params}
          style={{
            ...params.style,
            minHeight: 30,
          }}
          key={`Option-${option}`}
        >
          {option}
        </li>
      )}
    />
  );
};

export default NitroAutocompleteMulti;
